import { apiClient, API_PRX } from '@indipia/shared';

const BASE = `${API_PRX.MEMBER}/company/promo`;

export interface CompanyPromoTagDto {
  tagId: number;
  tagType: string;
  value: string;
  sortOrder: number | null;
}

export interface CompanyPromoResponse {
  logoUrl: string | null;
  heroPhotoUrl: string | null;
  promoTagline: string | null;
  intro: string | null;
  serviceArea: string | null;
  useYn: 'Y' | 'N';
  tags: CompanyPromoTagDto[];
}

/** P1 */
export async function fetchCompanyPromo(): Promise<CompanyPromoResponse> {
  const res = await apiClient.get(BASE);
  return res.data.data as CompanyPromoResponse;
}

/** P2 — 전달된 필드만 부분 저장(undefined는 폼에 안 실음) */
export async function updateCompanyPromo(params: {
  promoTagline?: string;
  intro?: string;
  serviceArea?: string;
  useYn?: 'Y' | 'N';
  logo?: File;
  heroPhoto?: File;
}): Promise<CompanyPromoResponse> {
  const form = new FormData();
  if (params.promoTagline !== undefined) form.append('promoTagline', params.promoTagline);
  if (params.intro !== undefined) form.append('intro', params.intro);
  if (params.serviceArea !== undefined) form.append('serviceArea', params.serviceArea);
  if (params.useYn !== undefined) form.append('useYn', params.useYn);
  if (params.logo) form.append('logo', params.logo);
  if (params.heroPhoto) form.append('heroPhoto', params.heroPhoto);
  const res = await apiClient.patch(BASE, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data as CompanyPromoResponse;
}

/** P3 */
export async function deleteHeroPhoto(): Promise<void> {
  await apiClient.delete(`${BASE}/hero-photo`);
}

/** 로고 삭제 — 내 정보 [삭제] */
export async function deleteLogo(): Promise<void> {
  await apiClient.delete(`${BASE}/logo`);
}

/** P4 */
export async function addCompanyPromoTag(tagType: string, value: string): Promise<number> {
  const res = await apiClient.post(`${BASE}/tags`, { tagType, value });
  return res.data.data.tag_id as number;
}

/** P5 */
export async function deleteCompanyPromoTag(tagId: number): Promise<void> {
  await apiClient.delete(`${BASE}/tags/${tagId}`);
}
